import React from 'react'
import { NOT_FOUND } from 'redux-first-router'

import Dashboard from '@/view/Dashboard'
import NewsletterEdit from '@/view/Dashboard/editNewsletter'

import Products from '@/view/Products'
import NewProduct from '@/view/Products/newProduct'
import EditProduct from '@/view/Products/editProduct'

import Users from '@/view/Users'
import EditUser from '@/view/Users/editUser'
import NewUser from '@/view/Users/newUser'

import Components, { editComponents as EditComponents } from '@/view/Components'

import Contacts from '@/view/Contacts'
import EditContact from '@/view/Contacts/editContact'
import NewContact from '@/view/Contacts/newContact'

import Login from '@/view/Login'
import Reset from '@/view/Login/Reset'

import loadStatistics from '@/state/sagas/statistics'
import redirectNewBuild from '@/state/sagas/build'

import {
  ROUTE_DASHBOARD,
  ROUTE_NEWSLETTERS_EDIT,
  ROUTE_NEWSLETTERS_NEW,
  ROUTE_COMPONENTS,
  ROUTE_COMPONENTS_NEW,
  ROUTE_COMPONENTS_EDIT,
  ROUTE_PRODUCTS,
  ROUTE_PRODUCTS_NEW,
  ROUTE_PRODUCTS_EDIT,
  ROUTE_CONTACTS,
  ROUTE_CONTACTS_NEW,
  ROUTE_CONTACTS_EDIT,
  ROUTE_USERS,
  ROUTE_USERS_EDIT,
  ROUTE_USERS_NEW,
  ROUTE_LOGIN,
  ROUTE_RESET,
  ROUTE_REGISTER,
} from '@/state/types/routes'

const Register = () => <div>Register</div>

const routesMap = {
  [ROUTE_DASHBOARD]: {
    name: 'Newsletters',
    path: '/',
    resource: 'newsletters',
    role: 'admin',
    saga: loadStatistics,
    view: Dashboard,
  },
  // New should be before the edit route as they are sharing starting path
  [ROUTE_NEWSLETTERS_NEW]: {
    hidden: true,
    name: 'New Newsletter',
    notInMenu: true,
    parent: ROUTE_DASHBOARD,
    path: '/newsletters/new/:step(build|content|add)?',
    redirectToList: ROUTE_DASHBOARD,
    relations: ['products', 'contacts'],
    saga: redirectNewBuild,
    view: NewsletterEdit,
  },
  [ROUTE_NEWSLETTERS_EDIT]: {
    // hasOne: ['products', 'contacts'],
    hidden: true,
    name: 'Edit Newsletter',
    notInMenu: true,
    parent: ROUTE_DASHBOARD,
    path: '/newsletters/:id/:step(build|content|add)?',
    resource: 'newsletters',
    redirectToList: ROUTE_DASHBOARD,
    relations: ['products', 'contacts'],
    saga: redirectNewBuild,
    view: NewsletterEdit,
  },
  [ROUTE_COMPONENTS]: {
    action: { label: 'Add new component', target: ROUTE_COMPONENTS_NEW },
    name: 'Components',
    path: '/components',
    resource: 'components',
    role: 'admin',
    view: Components,
  },
  [ROUTE_COMPONENTS_NEW]: {
    name: 'Add new',
    notInMenu: true,
    parent: ROUTE_COMPONENTS,
    path: '/components/new',
    redirectToList: ROUTE_COMPONENTS,
    role: 'admin',
    view: EditComponents,
  },
  [ROUTE_COMPONENTS_EDIT]: {
    name: 'Edit',
    notInMenu: true,
    parent: ROUTE_COMPONENTS,
    path: '/components/:id',
    resource: 'components',
    redirectToList: ROUTE_COMPONENTS,
    role: 'admin',
    view: EditComponents,
  },
  [ROUTE_PRODUCTS]: {
    action: { label: 'Add new product', target: ROUTE_PRODUCTS_NEW },
    name: 'Products',
    path: '/products',
    resource: 'products',
    role: 'admin',
    view: Products,
  },
  [ROUTE_PRODUCTS_NEW]: {
    name: 'Add new',
    notInMenu: true,
    parent: ROUTE_PRODUCTS,
    path: '/products/new',
    redirectToList: ROUTE_PRODUCTS,
    role: 'admin',
    view: NewProduct,
  },
  [ROUTE_PRODUCTS_EDIT]: {
    name: 'Edit',
    notInMenu: true,
    parent: ROUTE_PRODUCTS,
    path: '/products/:id',
    resource: 'products',
    redirectToList: ROUTE_PRODUCTS,
    role: 'admin',
    view: EditProduct,
  },
  [ROUTE_CONTACTS]: {
    action: { label: 'Add new contact', target: ROUTE_CONTACTS_NEW },
    name: 'Contacts',
    path: '/contacts',
    resource: 'contacts',
    role: 'admin',
    view: Contacts,
  },
  [ROUTE_CONTACTS_NEW]: {
    name: 'New contact',
    notInMenu: true,
    parent: ROUTE_CONTACTS,
    path: '/contacts/new',
    redirectToList: ROUTE_CONTACTS,
    role: 'admin',
    view: NewContact,
  },
  [ROUTE_CONTACTS_EDIT]: {
    name: 'Edit',
    notInMenu: true,
    parent: ROUTE_CONTACTS,
    path: '/contacts/:id',
    resource: 'contacts',
    redirectToList: ROUTE_CONTACTS,
    role: 'admin',
    view: EditContact,
  },
  [ROUTE_USERS]: {
    action: { label: 'Add new user', target: ROUTE_USERS_NEW },
    name: 'Team',
    path: '/team',
    resource: 'users',
    role: 'admin',
    view: Users,
  },
  [ROUTE_USERS_NEW]: {
    name: 'Add new',
    notInMenu: true,
    parent: ROUTE_USERS,
    path: '/team/new',
    redirectToList: ROUTE_USERS,
    role: 'admin',
    view: NewUser,
  },
  [ROUTE_USERS_EDIT]: {
    name: 'Edit',
    notInMenu: true,
    parent: ROUTE_USERS,
    path: '/team/:id',
    resource: 'users',
    redirectToList: ROUTE_USERS,
    role: 'admin',
    view: EditUser,
  },
  [ROUTE_REGISTER]: {
    hidden: true,
    name: 'Register',
    path: '/register',
    view: Register,
  },
  [ROUTE_RESET]: {
    hidden: true,
    name: 'Reset',
    path: '/reset',
    view: Reset,
  },
  [ROUTE_LOGIN]: {
    hidden: true,
    name: 'Login',
    path: '/login',
    view: Login,
  },
  [NOT_FOUND]: ROUTE_LOGIN,
}

// Route can also be mapped like this : [ROTE_SOMETHING]: '/path',

export const routesIndex = Object.keys(routesMap)

export default routesMap



// WEBPACK FOOTER //
// ./state/routesMap.js